import React from 'react';
import {connect} from 'react-redux';
import {RootState} from '../../store';
import {IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonTitle, IonToolbar} from '@ionic/react';
import {RouteComponentProps, withRouter} from 'react-router';
import "./Menu.scss"

const routes = {
  pages: [
    {title: 'Wedstrijden', path: '/', icon: 'calendar'},
    {title: 'Dressuurproeven', path: '/dressage-protocols', icon: 'clipboard'},
    {title: 'Reglement', path: '/rules', icon: 'document'},
    {title: 'Over de app', path: '/about', icon: 'information-circle-outline'}
  ]
};

type Props = RouteComponentProps<{}> & ReturnType<typeof mapStateToProps>;

const Menu: React.SFC<Props> = ({isAuthenticated, history}) => {

  function renderlistItems(list: any[]) {
    return list
      .filter(route => !!route.path)
      .map((p) => (
        <IonMenuToggle key={p.title} auto-hide="false">
          <IonItem button onClick={() => history.push(p.path)}>
            <IonIcon slot="start" name={p.icon}>&nbsp;</IonIcon>
            <IonLabel>
              {p.title}
            </IonLabel>
          </IonItem>
        </IonMenuToggle>
      ));
  }

  return (
    <IonMenu contentId="main" type="overlay">
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>Menu</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent class="outer-content menu-content">
        <IonList>
          {renderlistItems(routes.pages)}
        </IonList>
      </IonContent>
    </IonMenu>
  );
};

const mapStateToProps = (state: RootState) => ({
  isAuthenticated: true
});

export default withRouter(connect(
  mapStateToProps
)(Menu));
